import React from 'react';

const CreateTemplateStepCounter = (props: any) => {
    const {currentStep, totalSteps} = props;

    return (
        <div>
            <div>{currentStep} / {totalSteps}</div>
        </div>
    );
};
export default CreateTemplateStepCounter;